import {ITEM_CONTROL_DIMENSIONS} from '@PosterWhiteboard/poster/poster-item-controls';
import type {AnimationFrameStateObject, ItemType} from '@PosterWhiteboard/items/item/item.types';
import type * as Fabric from '@postermywall/fabricjs-2';
import type {Item} from '@PosterWhiteboard/items/item/item.class';
import type {DeepPartial} from '@/global';

export const getScaledManualHorizontalPadding = (scaleX: number | undefined): number => {
  return 2 * getScaledManualLeftPadding(scaleX);
};

export const getScaledManualVerticalPadding = (scaleY: number | undefined): number => {
  return 2 * getScaledManualTopPadding(scaleY);
};

export const getScaledManualLeftPadding = (scaleX: number | undefined): number => {
  return scaleX ? ITEM_CONTROL_DIMENSIONS.PMW_ITEM_LEGACY_PADDING / scaleX : 1;
};

export const getScaledManualTopPadding = (scaleY: number | undefined): number => {
  return scaleY ? ITEM_CONTROL_DIMENSIONS.PMW_ITEM_LEGACY_PADDING / scaleY : 1;
};

export const getCumulativeVCScaleY = (vc: Fabric.Group | Fabric.Object | undefined): number => {
  return vc ? vc.scaleY * getCumulativeVCScaleY(vc.group) : 1;
};

export const getCumulativeVCScaleX = (vc: Fabric.Group | Fabric.Object | undefined): number => {
  return vc ? vc.scaleX * getCumulativeVCScaleX(vc.group) : 1;
};

export const getMaxDurationItem = (items: ItemType[]): ItemType | undefined => {
  let maxDurationItem;
  for (const item of items) {
    if (item && (!maxDurationItem || maxDurationItem.getPlayDuration() < item.getPlayDuration())) {
      maxDurationItem = item;
    }
  }
  return maxDurationItem;
};

export const getStaticValuesForAnimatingItem = (item: Item): DeepPartial<AnimationFrameStateObject> => {
  const defaultValues: Record<string, number> = {};
  const values: DeepPartial<AnimationFrameStateObject> = {};
  if (item.hasIntroAnimation() && item.introAnimation.animation.isAnimationPlaying) {
    Object.assign(defaultValues, {...item.introAnimation.animation.onCompleteValues});
  }
  if (item.hasOutroAnimation() && item.outroAnimation.animation.isAnimationPlaying) {
    Object.assign(defaultValues, {...item.outroAnimation.animation.startingAnimationValues});
  }
  if ('left' in defaultValues) {
    Object.assign(values, {left: defaultValues.left});
  }
  if ('top' in defaultValues) {
    Object.assign(values, {top: defaultValues.top});
  }
  if ('scaleX' in defaultValues) {
    Object.assign(values, {scaleX: defaultValues.scaleX});
  }
  if ('scaleY' in defaultValues) {
    Object.assign(values, {scaleY: defaultValues.scaleY});
  }
  if ('angle' in defaultValues) {
    Object.assign(values, {angle: defaultValues.angle});
  }
  if ('opacity' in defaultValues) {
    Object.assign(values, {alpha: defaultValues.opacity});
  }
  return values;
};
